module.exports = __webpack_public_path__ + "static/media/creator_id.web.2c211576.png";